// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__223aQ","content":"styles_content__32XoP"};